import type { FunctionComponent, ReactNode } from "react";
import { useCallback, useState } from "react";

import { Icon, Text } from "@smartsuite/react-ui/lib";
import { IconColorNames } from "@smartsuite/types";

import {
  StyledWrapper,
  StyledTitle,
  StyledIcon,
  StyledChildren,
} from "./styles";

interface SubConditionBoxProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  onClick?: () => void;
}

// eslint-disable-next-line import/no-unused-modules -- consumed by the upcoming Conditional Logic branches UI (Tasks 6-7)
export const SubConditionBox: FunctionComponent<SubConditionBoxProps> = ({
  title,
  children,
  defaultExpanded = false,
  onClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = useCallback(() => {
    setIsExpanded((prev) => !prev);
    onClick?.();
  }, [onClick]);

  return (
    <StyledWrapper>
      <StyledTitle onClick={handleToggle}>
        <StyledIcon isExpanded={isExpanded}>
          <Icon name="arrow-up-1" color={IconColorNames.dark} />
        </StyledIcon>
        <Text size="l" weight="semibold">
          {title}
        </Text>
      </StyledTitle>
      {isExpanded && <StyledChildren>{children}</StyledChildren>}
    </StyledWrapper>
  );
};
